"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./IconListItem.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconListItem = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    text,
    header,
    type,
    backgroundColor,
    color
  } = content;
  const componentJSX = /*#__PURE__*/_react.default.createElement("article", {
    className: "ter-icon-list-item",
    style: {
      backgroundColor: backgroundColor || "#F8F8FB"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-icon-list-item__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: type || "enclosed-arrow-right-dark-32px",
    size: "32px",
    color: color || "#242D2F"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-icon-list-item__content-wrapper"
  }, header && /*#__PURE__*/_react.default.createElement("h4", {
    className: "ter-icon-list-item__header",
    style: {
      color: color || "#242D2F"
    },
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
  }), text && (0, _checkForDangerouslySet.checkAndSet)(text, "ter-icon-list-item", null, color)));
  return componentJSX;
};
var _default = IconListItem;
exports.default = _default;
IconListItem.propTypes = {
  content: _propTypes.default.shape({
    header: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })
};